// extracted by mini-css-extract-plugin
export default {"loadingContainer":"RequireAdminAuth_loadingContainer__oXnMj","errorMessage":"RequireAdminAuth_errorMessage__9TlOd"};